export default () => ({
    data: null
})